import api from "../../../../service/api";
import routes from "../../../../service/apiRoutes";

export const listClients = (data) => api.get(`${routes.listClients}`, {params: data})
export const editClient = (id, data) => api.put(`${routes.client}?client_id=${id}`, data)